import React, { useEffect, useState } from "react";
import SideBar from "../SideBar";
import Navbar from "../Navbar";
import axiosClient from "../../../axios-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const AllReviews = () => {
  const [users, setUsers] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [reviewToDelete, setReviewToDelete] = useState(null);
  const [error, setError] = useState('');

  const [newReview, setNewReview] = useState({
    userId: "",
    reviewText: "",
    rating: "",
  });
  const reviewsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axiosClient.get("/reviews/allreviews");
        setReviews(response.data);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, []);

  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);

  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleBackClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleCreateReview = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setNewReview({
      userId: "",
      reviewText: "",
      rating: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'rating' && (value < 1 || value > 5)) {
      setError('Rating must be between 1 and 5.');
    } else {
      setError('');
      setNewReview({ ...newReview, [name]: value });
    }
  };

  const handleSubmitReview = async (e) => {
    e.preventDefault();
    try {
      const { userId, reviewText, rating } = newReview;
      await axiosClient.post("/reviews/addreview", { userId, reviewText, rating });
      setIsModalOpen(false);
      setNewReview({
        userId: "",
        reviewText: "",
        rating: "",
      });
      const response = await axiosClient.get("/reviews/allreviews");
      setReviews(response.data);
    } catch (error) {
      console.error("Error creating review:", error);
    }
  };

  const handleDeleteClick = (reviewId) => {
    setReviewToDelete(reviewId);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await axiosClient.delete(`/reviews/delete/${reviewToDelete}`);
      setReviews(reviews.filter(review => review._id !== reviewToDelete));
      setIsDeleteModalOpen(false);
      setReviewToDelete(null);
    } catch (error) {
      console.error("Error deleting review:", error);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
    setReviewToDelete(null);
  };

  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);

  // Fetch users from the API
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axiosClient.get("/users/userlist");
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  return (
    <>
      <div className="flex">
        <SideBar />
        <div className="flex-1">
          {/* <Navbar /> */}
          <div className="p-8" style={{ paddingLeft: "17rem" }}>
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold">All Reviews</h1>
              <button
                onClick={handleCreateReview}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Create Review
              </button>
            </div>
            <div className="flex justify-end mb-4">
              <input
                type="text"
                placeholder="Search by name or email..."
                className="border border-gray-300 rounded px-4 py-2 w-1/4"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th className="py-2 px-4 border-b border-gray-200 text-left">S No.</th>
                    <th className="py-2 px-4 border-b border-gray-200 text-left">Name</th>
                    <th className="py-2 px-4 border-b border-gray-200 text-left">Email</th>
                    <th className="py-2 px-4 border-b border-gray-200 text-left">Review</th>
                    <th className="py-2 px-4 border-b border-gray-200 text-left">Rating</th>
                    <th className="py-2 px-4 border-b border-gray-200 text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentReviews.map((review, index) => (
                    <tr key={review._id}>
                      <td className="py-2 px-4 border-b border-gray-200">{indexOfFirstReview + index + 1}</td>
                      <td className="py-2 px-4 border-b border-gray-200">{review.userId?.name || "N/A"}</td>
                      <td className="py-2 px-4 border-b border-gray-200">{review.userId?.email || "N/A"}</td>
                      <td className="py-2 px-4 border-b border-gray-200">{review.reviewText}</td>
                      <td className="py-2 px-4 border-b border-gray-200">{review.rating}</td>
                      <td className="py-2 px-4 border-b border-gray-200">
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="text-red-500 cursor-pointer"
                          onClick={() => handleDeleteClick(review._id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex justify-center mt-6 space-x-1">
                <button
                  className="flex items-center px-2 py-1 bg-white border rounded"
                  onClick={handleBackClick}
                  disabled={currentPage === 1}
                >
                  <MdKeyboardArrowLeft className="mr-2" />
                  Back
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    className={`px-3 py-1 mx-1 rounded ${currentPage === index + 1 ? "bg-blue-500 text-white" : "bg-gray-200"
                      }`}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  className="flex justify-between items-center px-3 py-1 bg-white border rounded"
                  onClick={handleNextClick}
                  disabled={currentPage === totalPages}
                >
                  <span>Next</span>
                  <MdKeyboardArrowRight className="ml-2" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded shadow-lg w-3/4 max-w-lg">
            <h2 className="text-2xl font-bold mb-4">Create Review</h2>
            <form onSubmit={handleSubmitReview}>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">User</label>
                <select
                  name="userId"
                  value={newReview.userId}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded"
                  required
                >
                  <option value="">Select User</option>
                  {users.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.name} ({user.email})
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Review</label>
                <textarea
                  name="reviewText"
                  value={newReview.reviewText}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded"
                  rows="4"
                  required
                ></textarea>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Rating</label>
                <input
                  type="number"
                  name="rating"
                  value={newReview.rating}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded"
                  min="1"
                  max="5"
                  required
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={handleModalClose}
                  className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded shadow-lg w-3/4 max-w-lg">
            <h2 className="text-2xl font-bold mb-4">Confirm Deletion</h2>
            <p>Are you sure you want to delete this review?</p>
            <div className="flex justify-end mt-4">
              <button
                onClick={handleDeleteCancel}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AllReviews;
